import { X } from 'lucide-react';

import { IconButton, type IconButtonProps } from '../atoms';

type Props = {
  className?: string;
  fill?: IconButtonProps['fill'];
  onClick?: () => void;
};

export function DialogCloseButton({
  fill = 'ghost',
  className,
  onClick,
}: Props): React.ReactElement {
  return (
    <IconButton fill={fill} textColor="inherit" onClick={onClick} className={className}>
      <X className="size-5" />
      <span className="sr-only">Close</span>
    </IconButton>
  );
}
